 $('.tab-fslider').slick({
  dots: false,
       
  infinite: false,
  speed: 300,
  slidesToShow: 4,
  slidesToScroll: 4,
   nextArrow: "<div class='slick-next'><svg xmlns=0http://www.w3.org/2000/svg' width='10' height='18' viewBox='0 0 10 18' fill='none'> <path d='M1 17L9 9L1 1' stroke='#151515' stroke-width='0.83' stroke-linecap='round' stroke-linejoin='round'/></svg></div>",
   prevArrow: "<div class='slick-prev'><svg xmlns='http://www.w3.org/2000/svg' width='10' height='18' viewBox='0 0 10 18' fill='none'><path d='M9 17L1 9L9 1' stroke='#151515' stroke-width='0.83' stroke-linecap='round' stroke-linejoin='round'/></svg></div>",
    responsive: [
    {
      breakpoint: 1090,
      settings: {
        slidesToShow: 3,
        slidesToScroll: 3,
        infinite: true,
        dots: false
      }
    },
    {
      breakpoint: 890,
      settings: {
        slidesToShow: 2,
        slidesToScroll: 2
      }
    },
    {
      breakpoint: 488,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1
      }
    }
    // You can unslick at a given breakpoint now by adding:
    // settings: "unslick"
    // instead of a settings object
  ]
});

// --------------------load more button--------------------------
  //  var products_on_page = $('.products-onpage');
  //  var next_url = products_on_page.data('next-url');

  //  var load_more_btn = $('.load-more_btn');
  // var load_more_spinner = $('.load-more_spinner');


  //  function loadMoreProducts() {
  //    $.ajax({
  //      url:next_url,
  //      type:'GET',
  //      dataType:'html',
  //      beforeSend: function () {
  //        load_more_btn.hide();
  //        load_more_spinner.show();
  //      }
  //    }).done(function(next_page){
  //      load_more_spinner.hide();
  //      var new_products = $(next_page).find('.products-onpage');
  //      var new_url = new_products.data('next-url');

  //      // if(new_url){
  //        load_more_btn.show();
  //      // }

  //      next_url = new_url;

  //      products_on_page.append(new_products.html());
  //    })
  //  }


// --------------------Filter js--------------------------

// document.addEventListener('DOMContentLoaded', function() {
//   // Check if the 'in-stock' filter is already applied in the URL
//   var url = new URL(window.location.href);
//   var params = new URLSearchParams(url.search);
//   var inStockToggle = document.getElementById('availability-toggle');
  
//   // If the filter is active, set the toggle to checked
//   if (params.get('filter.v.availability') === 'available') {
//     inStockToggle.checked = true;
//   }

//   // Function to toggle the filter
//   function toggleInStock() {
//     var url = new URL(window.location.href);
//     var params = new URLSearchParams(url.search);
    
//     // If the toggle is checked, add the in-stock filter
//     if (inStockToggle.checked) {
//       params.set('filter.v.availability', 'available');
//     } else {
//       // Remove the availability filter if unchecked
//       params.delete('filter.v.availability');
//     }
    
//     // Reload the page with the updated parameters
//     window.location.search = params.toString();
//   }

//   // Attach the function to the toggle
//   inStockToggle.addEventListener('click', toggleInStock);
// });

// new js for load more start
function initializeSortAndPagination() {
    $(document).ready(function () {
        $(document).on("click", ".facet-filters__sort option", function (e) {
            var sortValue = $(this).data("sort-value");
            loadContent(sortValue);
        }); 

        $(document).on("click", ".load-more", function (e) {
            e.preventDefault();
            $("#loading").show();
            var nextUrl = $(this).attr("href");

            $.ajax({
                url: nextUrl,
                success: function (data) {
                    $(".sInfinity-Loop").append($(data).find(".sInfinity-Loop").html());
                    $("#sInfinity-Pagination").html(
                        $(data).find("#sInfinity-Pagination").html()
                    );
                },
                complete: function () {
                    $("#loading").hide();  
                }
            });
        });
    });
}

initializeSortAndPagination();
// new js for load more end




/*Mega menu js start*/
document.addEventListener("DOMContentLoaded",() => {
    const items = document.querySelector(".header__inline-menu").querySelectorAll("details");
    items.forEach(item=> {
        item.addEventListener("mouseover", () => {
            item.setAttribute("open",true);
        });

        item.addEventListener("mouseleave", () => {
          setTimeout(() => {
              if (!item.matches(":hover")&& !item.querySelector("ul").matches(":hover")){
                item.removeAttribute("open");
              }
            }, 200);
          });

             item.querySelector("ul").addEventListener("mouseleave", () => {
              setTimeout(() => {
                  if (!item.matches(":hover") &&!item.querySelector("ul").matches(":hover")){
                      item.removeAttribute("open");
                    }
                  }, 200);
             });

    });
});
/*Mega menu js ends*/

